import { useContext, useState, useEffect, useRef } from "react";

import {
  StyleSheet,
  View,
  Text,
  ScrollView,
} from "react-native";
import SafeAreaView from "../components/SafeAreaView";

//import Ionicons from "react-native-vector-icons/Ionicons";
//import Feather from "react-native-vector-icons/Feather";

import { Ionicons } from "../components/VectorIcons";
import { Feather } from "../components/VectorIcons";

import CustomButton from "../components/CustomButton";
import InputField from "../components/InputField";
import { AuthContext } from "../context/AuthContext";
import PageHeader from "../components/PageHeader";
import * as Config from "../config";
import axios from "axios";
import qs from "qs";
import { EventRegister } from "react-native-event-listeners";
import CustomSwitch from "../components/CustomSwitch";
import SimplePress from "../components/SimplePress";
import { Modal } from "../components/Modal";
import { ChipType, dateValue, getSchemeStyle } from "../context/helper";
import ActivityScreen from "./activityscreen";

const ChangeMeasuringPointScreen = ({ navigation, route }) => {
  const schemeStyles = getSchemeStyle();

  const [dataLoaded, setDataLoaded] = useState(false);
  const { branchid, sensorid } = route.params;
  const { userToken, useFirm } = useContext(AuthContext);

  const [sensorName, setSensorName] = useState("");
  const [sensorSortID, setSensorSortID] = useState(0);
  const [sensorTempMin, setSensorTempMin] = useState("");
  const [sensorTempMax, setSensorTempMax] = useState("");

  const [sensorUseMin, setSensorUseMin] = useState(false);
  const [sensorUseMax, setSensorUseMax] = useState(false);
  const [sensorOffline, setSensorOffline] = useState(false);
  const [sensorErrorAlways, setSensorErrorAlways] = useState(false);
  const [sensorActive, setSensorActive] = useState(false);

  const [sensorSchedules, setSensorSchedules] = useState([]);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [editingScheduleIdx, setEditingScheduleIdx] = useState(null);
  const [editDays, setEditDays] = useState([false, false, false, false, false, false, false]);
  const [editTimeFrom, setEditTimeFrom] = useState("00:00");
  const [editTimeTo, setEditTimeTo] = useState("23:59");
  const [editSaveData, setEditSaveData] = useState(false);
  const [editSendError, setEditSendError] = useState(true);

  const [sensorBoard, setSensorBoard] = useState();

  const [resultText, setResultText] = useState("");

  const loadedData = useRef();

  const loadData = async () => {
    setDataLoaded(false);

    const url = `${Config.BASE_URL}/getdata`;
    let data = {
      action: "measuringpointchange",
      firmid: useFirm.current,
      sensorid: sensorid,
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + userToken,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        let _sensordata = res.data;
        console.log(_sensordata.data);
        if (_sensordata && _sensordata.result == "OK") {
          loadedData.current = _sensordata.data;

          setSensorName(_sensordata.data.name);
          setSensorSortID(_sensordata.data.sortid);
          setSensorUseMin(_sensordata.data.thresholds.min !== false);
          if (_sensordata.data.thresholds.min !== false)
            setSensorTempMin(_sensordata.data.thresholds.min.toString());
          setSensorUseMax(_sensordata.data.thresholds.max !== false);
          if (_sensordata.data.thresholds.max !== false)
            setSensorTempMax(_sensordata.data.thresholds.max.toString());

          setSensorOffline(_sensordata.data.offline);
          setSensorErrorAlways(_sensordata.data.errorsendalways);
          setSensorActive(_sensordata.data.isactive);

          setSensorBoard(_sensordata.data.board);
          setSensorSchedules(JSON.parse(_sensordata.data.schedules) || []);
        }
      })
      .catch((e) => {
        console.log(`MeasuringPointChange error ${e}`);
      });
    setDataLoaded(true);
  };

  const tempToNumber = (value) => {
    let val = 0;
    val = value * 1;
    val = val === NaN ? 0 : val;

    return val;
  };
  const sensorMinValue = () => {
    let min = 0;
    if (sensorUseMin) {
      min = tempToNumber(sensorTempMin);
      min = min == 0 ? -0.01 : min;
    }
    return min;
  };
  const sensorMaxValue = () => {
    let max = 0;
    if (sensorUseMax) {
      max = tempToNumber(sensorTempMax);
      max = max == 0 ? -0.01 : max;
    }
    return max;
  };

  const valueToNumber = (val) => {
    const isneg = val.includes("-");
    return (isneg ? "-" : "") + val.replace(/[^0-9]/g, "");
  };
  const saveSensorData = async (sData) => {
    return new Promise(async (resolve, reject) => {
      const url = `${Config.BASE_URL}/getdata`;
      let data = {
        action: "measuringpointsave",
        firmid: useFirm.current,
        ...sData,
      };

      let options = {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + userToken,
        },
        data: qs.stringify(data),
        url,
      };
      await axios(options)
        .then((res) => {
          console.log(res);
          let _data = res.data;
          if (_data && _data.result == "OK") {
            resolve({ result: "OK", reason: "" });
          } else if (_data && _data.result == "Failed")
            reject({ result: "Failed", code: 200, reason: "" });
        })
        .catch((e) => {
          console.log(e);
          reject({
            result: "Failed",
            code: e.response.status,
            reason: e.response.data,
          });
        });
    });
  };

  const fieldCheck = (sensName) => {
    return sensName.length > 0;
  };

  useEffect(() => {
    loadData();
  }, []);
  useEffect(() => {
    const emitBoardChange = EventRegister.addEventListener(
      Config.Events.BOARD_CHANGE,
      (msg) => {
        if (sensorBoard && sensorBoard.id === msg.boardid) {
          let changedData = { ...sensorBoard, bssid: msg.bssid };
          setSensorBoard(changedData);
        }
      }
    );
    return () => {
      EventRegister.removeEventListener(emitBoardChange);
    };
  }, [sensorBoard]);

  const DAY_NAMES = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

  const openScheduleEdit = (idx) => {
    if (idx === null) {
      setEditDays([true, true, true, true, true, false, false]);
      setEditTimeFrom("08:00");
      setEditTimeTo("18:00");
      setEditSaveData(true);
      setEditSendError(true);
    } else {
      const s = sensorSchedules[idx];
      setEditDays([...s.days]);
      setEditTimeFrom(s.timeFrom);
      setEditTimeTo(s.timeTo);
      setEditSaveData(s.saveData);
      setEditSendError(s.sendError);
    }
    setEditingScheduleIdx(idx);
    setScheduleModalOpen(true);
  };

  const fixScheduleTime = (scheduleTime) => {
    if (!scheduleTime) 
      scheduleTime = 0;

    if (scheduleTime.indexOf(':') == -1)
      scheduleTime += ':';
    
    const idx =scheduleTime.indexOf(':');

    scheduleTime += '00'

    return scheduleTime.substring(0,idx+3);
  }
  const saveScheduleEdit = () => {
    const newSchedule = {
//      id: editingScheduleIdx !== null ? sensorSchedules[editingScheduleIdx].id : 0,
      days: editDays,
      timeFrom: fixScheduleTime(editTimeFrom),
      timeTo: fixScheduleTime(editTimeTo),
      saveData: editSaveData,
      sendError: editSendError,
    };
    if (editingScheduleIdx === null) {
      setSensorSchedules([...sensorSchedules, newSchedule]);
    } else {
      const updated = [...sensorSchedules];
      updated[editingScheduleIdx] = newSchedule;
      setSensorSchedules(updated);
    }
    setScheduleModalOpen(false);
  };

  const deleteSchedule = (idx) => {
    setSensorSchedules(sensorSchedules.filter((_, i) => i !== idx));
  };

  const formatTimeInput = (text) => {
    const startdigits = text.replace(/[^0-9]/g, "").substring(0, 2);

    const maxdigits = startdigits>23?3:4;
    const leaddigits = maxdigits-2;

    const digits = text.replace(/[^0-9]/g, "").substring(0, maxdigits);
    if (digits.length >= maxdigits-1) return `${digits.substring(0, leaddigits)}:${digits.substring(leaddigits, maxdigits)}`;
    return digits;
  };

  if (!dataLoaded) {
    return (
      <ActivityScreen />
    );
  }

  return (
    <SafeAreaView style={[styles.mainArea, schemeStyles.Background]}>
      <PageHeader navigation={navigation} />
      <ScrollView style={styles.mainContainer}>
        <View>
          <Text style={[styles.titleText, schemeStyles.grayText]}>
            Messstellendaten ändern
          </Text>
        </View>
        <InputField
          style={[
            styles.inputField,
            schemeStyles.BorderC,
            schemeStyles.defaultText,
            schemeStyles.placeholderText,
          ]}
          label={"Bezeichnung der Messstelle"}
          icon={
            <Ionicons
              name="pricetag-outline"
              size={24}
              color={schemeStyles.grayIcon.color}
            />
          }
          value={sensorName}
          onChangeText={(text) => setSensorName(text)}
        />
        <View style={[styles.switchInputContainer, schemeStyles.BorderC]}>
          <InputField
            inputMode={"numeric"}
            style={[
              styles.switchInputField,
              schemeStyles.defaultText,
              schemeStyles.placeholderText,
            ]}
            label={"Temperatur minimum"}
            icon={
              <Feather
                name="minimize"
                size={24}
                color={
                  sensorUseMin
                    ? schemeStyles.grayIcon.color
                    : schemeStyles.disabledIcon.color
                }
              />
            }
            value={sensorUseMin ? sensorTempMin : undefined}
            onChangeText={(text) => setSensorTempMin(valueToNumber(text))}
            disabled={!sensorUseMin}
          />
          <CustomSwitch
            onColor={schemeStyles.switchColors.blueOnColor}
            offColor={schemeStyles.switchColors.offColor}
            disabledColor={schemeStyles.switchColors.disabledColor}
            circleActiveColor={schemeStyles.switchColors.circleActiveColor}
            circleInActiveColor={schemeStyles.switchColors.circleInActiveColor}
            value={sensorUseMin}
            onValueChange={(val) => {
              setSensorUseMin(val);
            }}
          />
        </View>
        <View style={[styles.switchInputContainer, schemeStyles.BorderC]}>
          <InputField
            inputMode={"numeric"}
            style={[
              styles.switchInputField,
              schemeStyles.defaultText,
              schemeStyles.placeholderText,
            ]}
            label={"Temperatur maximum"}
            icon={
              <Feather
                name="maximize"
                size={24}
                color={
                  sensorUseMax
                    ? schemeStyles.grayIcon.color
                    : schemeStyles.disabledIcon.color
                }
              />
            }
            value={sensorUseMax ? sensorTempMax : undefined}
            onChangeText={(text) => setSensorTempMax(valueToNumber(text))}
            disabled={!sensorUseMax}
          />
          <CustomSwitch
            onColor={schemeStyles.switchColors.blueOnColor}
            offColor={schemeStyles.switchColors.offColor}
            disabledColor={schemeStyles.switchColors.disabledColor}
            circleActiveColor={schemeStyles.switchColors.circleActiveColor}
            circleInActiveColor={schemeStyles.switchColors.circleInActiveColor}
            value={sensorUseMax}
            onValueChange={(val) => {
              setSensorUseMax(val);
            }}
          />
        </View>
        <View style={styles.switchContainer}>
          <Text style={[styles.switchText, schemeStyles.defaultText]}>
            Offline-Sensor
          </Text>
          <CustomSwitch
            onColor={schemeStyles.switchColors.blueOnColor}
            offColor={schemeStyles.switchColors.offColor}
            disabledColor={schemeStyles.switchColors.disabledColor}
            circleActiveColor={schemeStyles.switchColors.circleActiveColor}
            circleInActiveColor={schemeStyles.switchColors.circleInActiveColor}
            value={sensorOffline}
            onValueChange={(val) => {
              setSensorOffline(val);
            }}
          />
        </View>
        <View style={styles.switchContainer}>
          <Text style={[styles.switchText, schemeStyles.defaultText]}>
            Fehlermeldungen immer versenden
          </Text>
          <CustomSwitch
            onColor={schemeStyles.switchColors.blueOnColor}
            offColor={schemeStyles.switchColors.offColor}
            disabledColor={schemeStyles.switchColors.disabledColor}
            circleActiveColor={schemeStyles.switchColors.circleActiveColor}
            circleInActiveColor={schemeStyles.switchColors.circleInActiveColor}
            value={sensorErrorAlways}
            onValueChange={(val) => {
              setSensorErrorAlways(val);
            }}
          />
        </View>
        <View style={styles.switchContainer}>
          <Text style={[styles.switchText, schemeStyles.defaultText]}>
            Sensor aktiv
          </Text>
          <CustomSwitch
            onColor={schemeStyles.switchColors.blueOnColor}
            offColor={schemeStyles.switchColors.offColor}
            disabledColor={schemeStyles.switchColors.disabledColor}
            circleActiveColor={schemeStyles.switchColors.circleActiveColor}
            circleInActiveColor={schemeStyles.switchColors.circleInActiveColor}
            value={sensorActive}
            onValueChange={(val) => {
              setSensorActive(val);
            }}
          />
        </View>
        <View style={[styles.scheduleSection, schemeStyles.BorderC]}>
          <View style={styles.scheduleSectionHeader}>
            <Text style={[styles.scheduleSectionTitle, schemeStyles.defaultText]}>
              Zeitbasierte Einstellungen
            </Text>
            <SimplePress onPress={() => openScheduleEdit(null)}>
              <Ionicons name="add-circle-outline" size={28} color={schemeStyles.grayIcon.color} />
            </SimplePress>
          </View>
          {sensorSchedules.length === 0 ? (
            <Text style={[styles.scheduleEmptyText, schemeStyles.silverText]}>
              Keine Zeitregeln konfiguriert
            </Text>
          ) : (
            sensorSchedules.map((s, idx) => (
              <SimplePress key={idx} onPress={() => openScheduleEdit(idx)}>
                <View style={styles.scheduleItem}>
                  <View style={styles.scheduleItemLeft}>
                    <Text style={[styles.scheduleItemDays, schemeStyles.defaultText]}>
                      {DAY_NAMES.filter((_, i) => s.days[i]).join(" ") || "–"}
                    </Text>
                    <Text style={[styles.scheduleItemTime, schemeStyles.lightGrayText]}>
                      {s.timeFrom} – {s.timeTo}
                    </Text>
                    <Text style={[styles.scheduleItemAction, schemeStyles.silverText]}>
                      {[s.saveData && "Speichern", s.sendError && "Fehler"].filter(Boolean).join(" + ") || "Keine Aktion"}
                    </Text>
                  </View>
                  <SimplePress onPress={() => deleteSchedule(idx)} hitSlop={8}>
                    <Ionicons name="trash-outline" size={22} color={schemeStyles.grayIcon.color} />
                  </SimplePress>
                </View>
              </SimplePress>
            ))
          )}
        </View>
        <View style={[styles.boardContainer, schemeStyles.BorderC]}>
          <View style={styles.boardTopContainer}>
            <Text
              style={[styles.boardMainText, schemeStyles.defaultText]}
            >{`Sensorbox ${
              sensorBoard.id === 0 ? "nicht zugeordnet" : `#${sensorBoard.id}`
            }`}</Text>
            {sensorBoard.id !== 0 && (
              <SimplePress
                onPress={() => {
                  navigation.navigate("ChangeBoard", {
                    boardid: sensorBoard.id,
                    changepoint: false,
                  });
                }}
              >
                <Ionicons
                  name="ellipsis-vertical"
                  size={30}
                  color={schemeStyles.grayIcon.color}
                />
              </SimplePress>
            )}
          </View>
          {sensorBoard.id !== 0 && (
            <View style={styles.boardInfoContainer}>
              <View style={styles.boardLine}>
                <Text
                  style={[
                    styles.boardInfoText,
                    styles.boardInfoMainCol,
                    schemeStyles.defaultText,
                  ]}
                >
                  Boardtoken:
                </Text>
                <Text style={[styles.boardInfoText, schemeStyles.defaultText]}>
                  {sensorBoard.token}
                </Text>
              </View>
              <View style={styles.boardLine}>
                <Text
                  style={[
                    styles.boardInfoText,
                    styles.boardInfoMainCol,
                    schemeStyles.defaultText,
                  ]}
                >
                  Boardversion:
                </Text>
                <Text style={[styles.boardInfoText, schemeStyles.defaultText]}>
                  {sensorBoard.boardversion ? sensorBoard.boardversion : "n.A."}
                </Text>
              </View>
              <View style={styles.boardLine}>
                <Text
                  style={[
                    styles.boardInfoText,
                    styles.boardInfoMainCol,
                    schemeStyles.defaultText,
                  ]}
                >
                  Chiptyp:
                </Text>
                <Text style={[styles.boardInfoText, schemeStyles.defaultText]}>
                  {ChipType.chipName(sensorBoard.chiptype)}
                </Text>
              </View>
              <View style={styles.boardLine}>
                <Text
                  style={[
                    styles.boardInfoText,
                    styles.boardInfoMainCol,
                    schemeStyles.defaultText,
                  ]}
                >
                  Produktionsdatum:
                </Text>
                <Text style={[styles.boardInfoText, schemeStyles.defaultText]}>
                  {dateValue(sensorBoard.producedate)}
                </Text>
              </View>
              {sensorBoard.bssid && (
                <View style={styles.boardLine}>
                  <Text
                    style={[
                      styles.boardInfoText,
                      styles.boardInfoMainCol,
                      schemeStyles.defaultText,
                    ]}
                  >
                    AccessPoint:
                  </Text>
                  <Text
                    style={[styles.boardInfoText, schemeStyles.defaultText]}
                  >
                    {sensorBoard.bssid}
                  </Text>
                </View>
              )}
            </View>
          )}
        </View>
        <View style={styles.resultContainer}>
          <Text style={schemeStyles.resultText}>{resultText}</Text>
        </View>
        <View style={styles.buttonContainer}>
          <CustomButton
            style={[styles.buttons, schemeStyles.buttonText]}
            disabled={!fieldCheck(sensorName)}
            onPress={() => {
              let sensorObj = {
                sensorID: sensorid,
                sensorName: sensorName,
                sensorSortID: sensorSortID,
                sensorMin: sensorMinValue(),
                sensorMax: sensorMaxValue(),
                sensorOffline: sensorOffline ? 1 : 0,
                sensorErrorAlways: sensorErrorAlways ? 1 : 0,
                sensorActive: sensorActive ? 1 : 0,
                sensorSchedules: JSON.stringify(sensorSchedules),
              };
              saveSensorData(sensorObj)
                .then((res) => {
                  console.log(res);
                  sensorObj = {
                    ...sensorObj,
                    activeChange: sensorActive != loadedData.current.isactive,
                    sensorMin: sensorUseMin
                      ? tempToNumber(sensorTempMin)
                      : false,
                    sensorMax: sensorUseMax
                      ? tempToNumber(sensorTempMax)
                      : false,
                  };
                  EventRegister.emit(Config.Events.SENSOR_CHANGE, sensorObj);
                  navigation.goBack();
                })
                .catch((res) => {
                  setResultText(res.reason);
                });
            }}
          >
            OK
          </CustomButton>
          <View style={styles.spacer} />
          <CustomButton
            style={[styles.buttons, styles.backButton, schemeStyles.buttonText]}
            onPress={() => {
              navigation.goBack();
            }}
          >
            Zurück
          </CustomButton>
        </View>
      </ScrollView>
      <Modal isOpen={scheduleModalOpen} withInput={true}>
        <View style={[styles.modalContent, schemeStyles.Background]}>
          <Text style={[styles.modalTitle, schemeStyles.defaultText]}>
            {editingScheduleIdx === null ? "Neue Zeitregel" : "Zeitregel bearbeiten"}
          </Text>
          <Text style={[styles.modalLabel, schemeStyles.defaultText]}>Wochentage</Text>
          <View style={styles.daySelector}>
            {DAY_NAMES.map((name, i) => (
              <SimplePress
                key={i}
                onPress={() => {
                  const updated = [...editDays];
                  updated[i] = !updated[i];
                  setEditDays(updated);
                }}
              >
                <View style={[
                  styles.dayChip,
                  { borderColor: schemeStyles.grayIcon.color },
                  editDays[i] && styles.dayChipActive,
                ]}>
                  <Text style={[
                    styles.dayChipText,
                    editDays[i] ? styles.dayChipTextActive : schemeStyles.defaultText,
                  ]}>
                    {name}
                  </Text>
                </View>
              </SimplePress>
            ))}
          </View>
          <View style={styles.timeRow}>
            <View style={styles.timeInputWrapper}>
              <Text style={[styles.modalLabel, schemeStyles.defaultText]}>Von</Text>
              <InputField
                inputMode="numeric"
                style={[styles.timeInput, schemeStyles.defaultText, schemeStyles.placeholderText]}
                label="08:00"
                value={editTimeFrom}
                onChangeText={(text) => setEditTimeFrom(formatTimeInput(text))}
              />
            </View>
            <View style={styles.timeInputWrapper}>
              <Text style={[styles.modalLabel, schemeStyles.defaultText]}>Bis</Text>
              <InputField
                inputMode="numeric"
                style={[styles.timeInput, schemeStyles.defaultText, schemeStyles.placeholderText]}
                label="18:00"
                value={editTimeTo}
                onChangeText={(text) => setEditTimeTo(formatTimeInput(text))}
              />
            </View>
          </View>
          <View style={styles.modalSwitch}>
            <Text style={[styles.modalSwitchText, schemeStyles.defaultText]}>Messwerte speichern</Text>
            <CustomSwitch
              onColor={schemeStyles.switchColors.blueOnColor}
              offColor={schemeStyles.switchColors.offColor}
              disabledColor={schemeStyles.switchColors.disabledColor}
              circleActiveColor={schemeStyles.switchColors.circleActiveColor}
              circleInActiveColor={schemeStyles.switchColors.circleInActiveColor}
              value={editSaveData}
              onValueChange={setEditSaveData}
            />
          </View>
          <View style={styles.modalSwitch}>
            <Text style={[styles.modalSwitchText, schemeStyles.defaultText]}>Fehler versenden</Text>
            <CustomSwitch
              onColor={schemeStyles.switchColors.blueOnColor}
              offColor={schemeStyles.switchColors.offColor}
              disabledColor={schemeStyles.switchColors.disabledColor}
              circleActiveColor={schemeStyles.switchColors.circleActiveColor}
              circleInActiveColor={schemeStyles.switchColors.circleInActiveColor}
              value={editSendError}
              onValueChange={setEditSendError}
            />
          </View>
          <View style={styles.buttonContainer}>
            <CustomButton
              style={[styles.buttons, schemeStyles.buttonText]}
              onPress={saveScheduleEdit}
            >
              Übernehmen
            </CustomButton>
            <View style={styles.spacer} />
            <CustomButton
              style={[styles.buttons, styles.backButton, schemeStyles.buttonText]}
              onPress={() => setScheduleModalOpen(false)}
            >
              Abbrechen
            </CustomButton>
          </View>
        </View>
      </Modal>
    </SafeAreaView>
  );
};

export default ChangeMeasuringPointScreen;

const styles = StyleSheet.create({
  mainArea: {
    flex: 1,
    paddingTop: 20,
  },
  mainContainer: {
    paddingHorizontal: 25,
  },
  titleText: {
    fontFamily: "Roboto-Medium",
    fontSize: 28,
    fontWeight: "500",
    marginBottom: 30,
  },
  continueText: {
    fontFamily: "Roboto-Medium",
    fontSize: 16,
    color: "#555",
    marginBottom: 20,
  },
  switchInputContainer: {
    flexDirection: "row",
    borderBottomWidth: 1,
    marginBottom: 20,
    paddingRight: 10,
  },
  inputField: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
    marginBottom: 20,
  },
  switchInputField: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
    flex: 1,
    borderBottomWidth: 0,
    marginBottom: 0,
    marginRight : 15
  },
  switchContainer: {
    flexDirection: "row",
    paddingVertical: 15,
    paddingRight: 10,
  },
  switchText: {
    fontFamily: "Roboto-Regular",
    fontSize: 16,
    flex: 1,
  },
  buttonContainer: {
    flexDirection: "row",
  },
  buttons: {
    flex: 1,
  },
  backButton: {
    backgroundColor: "#555",
  },
  spacer: {
    width: 10,
  },
  boardContainer: {
    borderBottomWidth: 1,
    borderTopWidth: 1,
    paddingVertical: 15,
  },
  boardTopContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 10,
  },
  boardMainText: {
    flex: 1,
    fontFamily: "Roboto-Regular",
    fontSize: 16,
  },
  boardInfoContainer: {
    marginLeft: 10,
  },
  boardLine: {
    flexDirection: "row",
  },
  boardInfoMainCol: {
    width: 120,
  },
  boardInfoText: {
    fontFamily: "Roboto-Regular",
    fontSize: 11,
  },
  resultContainer: {
    marginBottom: 10,
  },
  scheduleSection: {
    borderTopWidth: 1,
    borderBottomWidth: 1,
    paddingVertical: 15,
    marginBottom: 20,
  },
  scheduleSectionHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 6,
  },
  scheduleSectionTitle: {
    flex: 1,
    fontFamily: "Roboto-Regular",
    fontSize: 16,
  },
  scheduleEmptyText: {
    fontFamily: "Roboto-Regular",
    fontSize: 13,
    marginLeft: 4,
    paddingVertical: 6,
  },
  scheduleItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 8,
    marginRight: 4,
  },
  scheduleItemLeft: {
    flex: 1,
  },
  scheduleItemDays: {
    fontFamily: "Roboto-Medium",
    fontSize: 14,
  },
  scheduleItemTime: {
    fontFamily: "Roboto-Regular",
    fontSize: 13,
  },
  scheduleItemAction: {
    fontFamily: "Roboto-Regular",
    fontSize: 12,
  },
  modalContent: {
    width: "100%",
    maxWidth: 600,
    borderRadius: 12,
    padding: 20,
    elevation: 5,
  },
  modalTitle: {
    fontFamily: "Roboto-Medium",
    fontSize: 18,
    marginBottom: 16,
  },
  modalLabel: {
    fontFamily: "Roboto-Regular",
    fontSize: 14,
    marginBottom: 6,
  },
  daySelector: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: 16,
  },
  dayChip: {
    borderWidth: 1.5,
    borderRadius: 16,
    paddingHorizontal: 10,
    paddingVertical: 4,
    marginRight: 6,
    marginBottom: 6,
  },
  dayChipActive: {
    backgroundColor: "#4785b8",
    borderColor: "#4785b8",
  },
  dayChipText: {
    fontFamily: "Roboto-Medium",
    fontSize: 13,
  },
  dayChipTextActive: {
    color: "#ffffff",
  },
  timeRow: {
    flexDirection: "row",
    marginBottom: 8,
  },
  timeInputWrapper: {
    flex: 1,
    marginRight: 12,
  },
  timeInput: {
    fontFamily: "Roboto-Regular",
    fontSize: 16,
  },
  modalSwitch: {
    flexDirection: "row",
    paddingVertical: 10,
    alignItems: "center",
  },
  modalSwitchText: {
    flex: 1,
    fontFamily: "Roboto-Regular",
    fontSize: 15,
  },
});
